import React from "react";

const PommeDeTerre = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="53.31"
        height="56.534"
        viewBox="0 0 53.31 56.534"
      >
        <g
          id="Group_18082"
          data-name="Group 18082"
          transform="translate(-31.124 -261.361)"
        >
          <g id="Group_18019" data-name="Group 18019">
            <path
              id="Path_19070"
              data-name="Path 19070"
              d="M84.192,278.9a25.276,25.276,0,0,0-.759-3.56,19.556,19.556,0,0,0-4.737-8.372c.275-.276-1.459-1.29-3.38-2.282-2.032-1.049-4.274-2.073-4.568-2.17a24.458,24.458,0,0,0-10.789-.931,33.956,33.956,0,0,0-14.516,5.846,33.917,33.917,0,0,0-12.555,14.81c-3.907,9.561-.854,17.872,4.563,25.971l.287-.287-.287.287c.039.058.082.115.121.173.63.932,1.3,1.833,2.017,2.694.514.618,1.05,1.22,1.625,1.789a16.907,16.907,0,0,0,11.058,5.007c7.128.368,14.443-4.316,18.524-9.937a22.215,22.215,0,0,0,2.846-5.28c1.192-3.185,1.6-6.8,3.332-9.759,2.333-3.986,7.59-5.859,7.458-11.109A26.127,26.127,0,0,0,84.192,278.9Zm-11.6-5.825-.536.536Zm-2.181,2.182-.7.7Zm-5.326,5.325-.942.942ZM45.728,299.935l-1,1Zm2.514-2.514-.566.566Zm-4.694,4.694L42.3,303.359Zm-2.613,2.613-1.058,1.057Zm-2.666,2.666-.17.169Zm.7-.7.649-.649Zm13.036-13.036.537-.537Zm-2.426,2.426.028-.028Zm9.286-9.286L56.861,288.8Zm17.951-17.95.68-.681Z"
              fill="#eda43b"
            />
            <g id="Group_18018" data-name="Group 18018">
              <path
                id="Path_19071"
                data-name="Path 19071"
                d="M51.387,283.092c-1.393,2.184-5.966.217-7.459-.8-5.214-3.55.343-8.8,1.565-9.676,2.746-1.965,6.75-5.068,10.005-5.967,3.058-.844,9.4-2.983,12.009-.334C72.735,271.62,60.855,268.236,51.387,283.092Z"
                fill="#fee392"
              />
            </g>
          </g>
          <g
            id="Group_18026"
            data-name="Group 18026"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18020" data-name="Group 18020">
              <path
                id="Path_19072"
                data-name="Path 19072"
                d="M38.357,292.035a.588.588,0,1,1,.416-1l-.177.178a.338.338,0,1,0,0,.477l.177.178A.588.588,0,0,1,38.357,292.035Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18021" data-name="Group 18021">
              <path
                id="Path_19073"
                data-name="Path 19073"
                d="M44.836,290.775a.584.584,0,0,1-.416-.171.589.589,0,0,1,.832-.833l-.176.178a.338.338,0,1,0,0,.478l.176.177A.584.584,0,0,1,44.836,290.775Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18022" data-name="Group 18022">
              <path
                id="Path_19074"
                data-name="Path 19074"
                d="M41.1,285.777a.587.587,0,0,1-.416-1,.6.6,0,0,1,.832,0l-.177.176a.346.346,0,0,0-.477,0,.337.337,0,1,0,.477.477l.177.178A.588.588,0,0,1,41.1,285.777Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18023" data-name="Group 18023">
              <path
                id="Path_19075"
                data-name="Path 19075"
                d="M48,286.1a.589.589,0,1,1,.417-1.005l-.178.178a.342.342,0,0,0-.477,0,.338.338,0,0,0,.477.478l.178.177A.587.587,0,0,1,48,286.1Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18024" data-name="Group 18024">
              <path
                id="Path_19076"
                data-name="Path 19076"
                d="M54.477,284.844a.588.588,0,1,1,.416-1l-.175.177a.338.338,0,1,0,0,.478l.175.178A.587.587,0,0,1,54.477,284.844Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18025" data-name="Group 18025">
              <path
                id="Path_19077"
                data-name="Path 19077"
                d="M50.746,279.845a.587.587,0,1,1,.416-1l-.178.177a.337.337,0,1,0,0,.477l.178.178A.589.589,0,0,1,50.746,279.845Z"
                fill="#d1752a"
              />
            </g>
          </g>
          <g
            id="Group_18033"
            data-name="Group 18033"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18027" data-name="Group 18027">
              <path
                id="Path_19078"
                data-name="Path 19078"
                d="M39.6,280.2a.683.683,0,0,1-.078-.005.588.588,0,0,1-.283-1.049.613.613,0,0,1,.435-.118.587.587,0,0,1,.389.225l-.2.152a.34.34,0,0,0-.474-.061.33.33,0,0,0-.129.224.334.334,0,0,0,.067.25.34.34,0,0,0,.475.062l.152.2A.579.579,0,0,1,39.6,280.2Z"
                fill="#ea984e"
              />
            </g>
            <g id="Group_18028" data-name="Group 18028">
              <path
                id="Path_19079"
                data-name="Path 19079"
                d="M46.184,279.772a.663.663,0,0,1-.076-.005.587.587,0,0,1-.284-1.048.6.6,0,0,1,.434-.118.582.582,0,0,1,.39.224l-.2.152a.339.339,0,0,0-.475-.06.339.339,0,0,0-.061.474.342.342,0,0,0,.475.061l.152.2A.579.579,0,0,1,46.184,279.772Z"
                fill="#ea984e"
              />
            </g>
            <g id="Group_18029" data-name="Group 18029">
              <path
                id="Path_19080"
                data-name="Path 19080"
                d="M43.121,274.34a.659.659,0,0,1-.077-.005.588.588,0,1,1,.541-.943l-.2.153a.339.339,0,1,0-.312.542.346.346,0,0,0,.25-.068l.152.2A.575.575,0,0,1,43.121,274.34Z"
                fill="#ea984e"
              />
            </g>
            <g id="Group_18030" data-name="Group 18030">
              <path
                id="Path_19081"
                data-name="Path 19081"
                d="M49.917,275.543a.68.68,0,0,1-.077-.005.589.589,0,0,1-.39-.225.579.579,0,0,1-.118-.434.585.585,0,0,1,.225-.39.6.6,0,0,1,.434-.118.586.586,0,0,1,.39.224l-.2.153a.339.339,0,1,0-.062.474l.152.2A.581.581,0,0,1,49.917,275.543Z"
                fill="#ea984e"
              />
            </g>
            <g id="Group_18031" data-name="Group 18031">
              <path
                id="Path_19082"
                data-name="Path 19082"
                d="M56.5,275.12a.632.632,0,0,1-.077-.005.587.587,0,0,1-.39-.225.588.588,0,0,1,.106-.823.593.593,0,0,1,.434-.118.586.586,0,0,1,.391.224l-.2.152a.336.336,0,0,0-.224-.128.33.33,0,0,0-.25.067.338.338,0,0,0,.163.6.348.348,0,0,0,.25-.067l.152.2A.575.575,0,0,1,56.5,275.12Z"
                fill="#ea984e"
              />
            </g>
            <g id="Group_18032" data-name="Group 18032">
              <path
                id="Path_19083"
                data-name="Path 19083"
                d="M53.44,269.686a.587.587,0,0,1-.36-1.052.6.6,0,0,1,.435-.119.583.583,0,0,1,.389.225l-.2.152a.342.342,0,0,0-.225-.129.338.338,0,1,0,.164.6l.153.2A.588.588,0,0,1,53.44,269.686Z"
                fill="#ea984e"
              />
            </g>
          </g>
          <g
            id="Group_18040"
            data-name="Group 18040"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18034" data-name="Group 18034">
              <path
                id="Path_19084"
                data-name="Path 19084"
                d="M58.081,292.388a.588.588,0,1,1,.416-1l-.178.177a.334.334,0,0,0-.476,0,.333.333,0,0,0,0,.478.334.334,0,0,0,.476,0l.178.178A.589.589,0,0,1,58.081,292.388Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18035" data-name="Group 18035">
              <path
                id="Path_19085"
                data-name="Path 19085"
                d="M64.559,291.13a.589.589,0,1,1,.417-1.005l-.177.177a.345.345,0,0,0-.478,0,.338.338,0,0,0,.478.478l.177.178A.59.59,0,0,1,64.559,291.13Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18036" data-name="Group 18036">
              <path
                id="Path_19086"
                data-name="Path 19086"
                d="M60.828,286.132a.588.588,0,0,1-.416-1,.6.6,0,0,1,.833,0l-.178.175a.347.347,0,0,0-.477,0,.338.338,0,0,0,.477.478l.178.178A.592.592,0,0,1,60.828,286.132Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18037" data-name="Group 18037">
              <path
                id="Path_19087"
                data-name="Path 19087"
                d="M67.723,286.457a.588.588,0,0,1-.416-.171.587.587,0,0,1,0-.833.588.588,0,0,1,.831,0l-.178.178a.338.338,0,1,0,0,.477l.178.178A.592.592,0,0,1,67.723,286.457Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18038" data-name="Group 18038">
              <path
                id="Path_19088"
                data-name="Path 19088"
                d="M74.2,285.2a.589.589,0,1,1,.417-1.005l-.178.178a.342.342,0,0,0-.477,0,.337.337,0,0,0,.477.477l.178.178A.592.592,0,0,1,74.2,285.2Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18039" data-name="Group 18039">
              <path
                id="Path_19089"
                data-name="Path 19089"
                d="M70.47,280.2a.588.588,0,1,1,.416-1l-.176.178a.338.338,0,1,0,0,.476l.176.178A.59.59,0,0,1,70.47,280.2Z"
                fill="#d1752a"
              />
            </g>
          </g>
          <g
            id="Group_18045"
            data-name="Group 18045"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18041" data-name="Group 18041">
              <path
                id="Path_19090"
                data-name="Path 19090"
                d="M59.87,269.691a.588.588,0,1,1,.417-1l-.178.178a.342.342,0,0,0-.477,0,.337.337,0,0,0,0,.477.344.344,0,0,0,.477,0l.178.177A.587.587,0,0,1,59.87,269.691Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18042" data-name="Group 18042">
              <path
                id="Path_19091"
                data-name="Path 19091"
                d="M66.35,268.432a.58.58,0,0,1-.416-.173.588.588,0,0,1,.832-.832l-.178.178a.337.337,0,0,0-.477.477.344.344,0,0,0,.477,0l.178.176A.583.583,0,0,1,66.35,268.432Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18043" data-name="Group 18043">
              <path
                id="Path_19092"
                data-name="Path 19092"
                d="M62.618,263.433a.586.586,0,0,1-.416-.171.589.589,0,1,1,.832-.833l-.178.178a.337.337,0,1,0,0,.478l.178.177A.586.586,0,0,1,62.618,263.433Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18044" data-name="Group 18044">
              <path
                id="Path_19093"
                data-name="Path 19093"
                d="M69.512,265.068a.588.588,0,1,1,.416-1l-.176.178a.338.338,0,1,0,0,.476l.176.178A.59.59,0,0,1,69.512,265.068Z"
                fill="#d1752a"
              />
            </g>
          </g>
          <g
            id="Group_18052"
            data-name="Group 18052"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18046" data-name="Group 18046">
              <path
                id="Path_19094"
                data-name="Path 19094"
                d="M59.321,280.549a.666.666,0,0,1-.077-.005.588.588,0,0,1,.15-1.166.579.579,0,0,1,.391.223l-.2.153a.333.333,0,0,0-.225-.128.328.328,0,0,0-.25.067.337.337,0,0,0-.061.474.337.337,0,0,0,.224.129.346.346,0,0,0,.25-.068l.153.2A.58.58,0,0,1,59.321,280.549Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18047" data-name="Group 18047">
              <path
                id="Path_19095"
                data-name="Path 19095"
                d="M65.907,280.126a.646.646,0,0,1-.075-.005.588.588,0,0,1,.149-1.166.579.579,0,0,1,.391.223l-.2.153a.341.341,0,0,0-.225-.128.33.33,0,0,0-.25.067.34.34,0,0,0-.061.475.336.336,0,0,0,.224.128.344.344,0,0,0,.25-.068l.153.2A.58.58,0,0,1,65.907,280.126Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18048" data-name="Group 18048">
              <path
                id="Path_19096"
                data-name="Path 19096"
                d="M62.845,274.692a.588.588,0,0,1-.361-1.053.6.6,0,0,1,.435-.118.592.592,0,0,1,.39.225l-.2.152a.338.338,0,1,0-.31.542.352.352,0,0,0,.25-.067l.152.2A.579.579,0,0,1,62.845,274.692Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18049" data-name="Group 18049">
              <path
                id="Path_19097"
                data-name="Path 19097"
                d="M69.641,275.895a.587.587,0,0,1-.584-.662.577.577,0,0,1,.223-.39.606.606,0,0,1,.435-.119.587.587,0,0,1,.389.225l-.2.152a.338.338,0,1,0-.061.475l.152.2A.582.582,0,0,1,69.641,275.895Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18050" data-name="Group 18050">
              <path
                id="Path_19098"
                data-name="Path 19098"
                d="M76.227,275.472a.586.586,0,0,1-.36-1.051.6.6,0,0,1,.434-.119.582.582,0,0,1,.39.224l-.2.152a.342.342,0,0,0-.475-.06.34.34,0,0,0-.06.474.341.341,0,0,0,.475.061l.152.2A.584.584,0,0,1,76.227,275.472Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18051" data-name="Group 18051">
              <path
                id="Path_19099"
                data-name="Path 19099"
                d="M73.165,270.041a.68.68,0,0,1-.077,0,.592.592,0,0,1-.39-.225.577.577,0,0,1-.118-.433.584.584,0,0,1,.224-.391.593.593,0,0,1,.434-.118.584.584,0,0,1,.39.225l-.2.152a.342.342,0,0,0-.225-.129.33.33,0,0,0-.25.067.339.339,0,0,0,.414.536l.152.2A.581.581,0,0,1,73.165,270.041Z"
                fill="#d1752a"
              />
            </g>
          </g>
          <g
            id="Group_18053"
            data-name="Group 18053"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19100"
              data-name="Path 19100"
              d="M58.239,301.722a.589.589,0,0,1-.416-.17.6.6,0,0,1-.173-.416.589.589,0,0,1,1-.417l-.178.177a.339.339,0,0,0-.577.24.34.34,0,0,0,.1.238.335.335,0,0,0,.477,0l.178.178A.587.587,0,0,1,58.239,301.722Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18054"
            data-name="Group 18054"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19101"
              data-name="Path 19101"
              d="M64.718,300.464a.588.588,0,0,1-.416-1,.6.6,0,0,1,.833,0l-.178.175a.349.349,0,0,0-.478,0,.34.34,0,0,0,0,.478.336.336,0,0,0,.478,0l.178.178A.593.593,0,0,1,64.718,300.464Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18055"
            data-name="Group 18055"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19102"
              data-name="Path 19102"
              d="M38.575,307.769a.584.584,0,0,1-.416-.171.588.588,0,1,1,.832-.832l-.178.178a.337.337,0,1,0,0,.477l.178.177A.586.586,0,0,1,38.575,307.769Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18056"
            data-name="Group 18056"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19103"
              data-name="Path 19103"
              d="M45.469,308.1a.588.588,0,1,1,.416-1l-.178.177a.338.338,0,1,0-.477.478.342.342,0,0,0,.477,0l.178.178A.591.591,0,0,1,45.469,308.1Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18057"
            data-name="Group 18057"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19104"
              data-name="Path 19104"
              d="M51.948,306.836a.588.588,0,1,1,.416-1l-.178.178a.337.337,0,1,0,0,.477l.178.178A.588.588,0,0,1,51.948,306.836Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18058"
            data-name="Group 18058"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19105"
              data-name="Path 19105"
              d="M50.436,301.913h0a.589.589,0,1,1,.417-1.005l-.175.178a.338.338,0,1,0-.241.577h0a.334.334,0,0,0,.24-.1l.177.178A.588.588,0,0,1,50.436,301.913Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18059"
            data-name="Group 18059"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19106"
              data-name="Path 19106"
              d="M37.066,302.187a.661.661,0,0,1-.075-.005.581.581,0,0,1-.391-.223.588.588,0,1,1,.931-.719l-.2.152a.341.341,0,0,0-.225-.128.338.338,0,0,0-.311.542.34.34,0,0,0,.474.061l.153.2A.58.58,0,0,1,37.066,302.187Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18060"
            data-name="Group 18060"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19107"
              data-name="Path 19107"
              d="M43.653,301.764a.587.587,0,0,1-.583-.662.588.588,0,0,1,1.048-.285l-.2.152a.336.336,0,0,0-.225-.127.328.328,0,0,0-.25.067.338.338,0,0,0,.413.535l.153.2A.583.583,0,0,1,43.653,301.764Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18061"
            data-name="Group 18061"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19108"
              data-name="Path 19108"
              d="M47.387,297.534a.584.584,0,0,1-.466-.229.588.588,0,0,1,.1-.824.588.588,0,0,1,.824.107l-.2.152a.338.338,0,1,0-.06.475l.152.2A.583.583,0,0,1,47.387,297.534Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18062"
            data-name="Group 18062"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19109"
              data-name="Path 19109"
              d="M53.974,297.112a.663.663,0,0,1-.076-.005.577.577,0,0,1-.39-.223.587.587,0,1,1,.929-.719l-.2.152a.338.338,0,1,0-.31.542.343.343,0,0,0,.25-.067l.152.2A.58.58,0,0,1,53.974,297.112Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18063"
            data-name="Group 18063"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <path
              id="Path_19110"
              data-name="Path 19110"
              d="M50.911,291.679c-.025,0-.051,0-.077,0a.592.592,0,0,1-.39-.225.585.585,0,0,1,.107-.824.594.594,0,0,1,.434-.118.584.584,0,0,1,.39.224l-.2.153a.338.338,0,0,0-.6.163.338.338,0,0,0,.542.311l.152.2A.581.581,0,0,1,50.911,291.679Z"
              fill="#d1752a"
            />
          </g>
          <g
            id="Group_18070"
            data-name="Group 18070"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18064" data-name="Group 18064">
              <path
                id="Path_19111"
                data-name="Path 19111"
                d="M49.347,316.47a.587.587,0,1,1,.416-1l-.176.177a.338.338,0,1,0,0,.477l.176.178A.589.589,0,0,1,49.347,316.47Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18065" data-name="Group 18065">
              <path
                id="Path_19112"
                data-name="Path 19112"
                d="M55.826,315.211a.588.588,0,1,1,.416-1l-.178.178a.337.337,0,1,0,0,.476l.178.178A.59.59,0,0,1,55.826,315.211Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18066" data-name="Group 18066">
              <path
                id="Path_19113"
                data-name="Path 19113"
                d="M52.1,310.214a.588.588,0,1,1,.416-1l-.178.177a.337.337,0,0,0-.477,0,.341.341,0,0,0,0,.479.337.337,0,0,0,.477,0l.178.178A.592.592,0,0,1,52.1,310.214Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18067" data-name="Group 18067">
              <path
                id="Path_19114"
                data-name="Path 19114"
                d="M58.988,310.539a.588.588,0,1,1,.416-1l-.176.178a.337.337,0,1,0,0,.476l.176.178A.587.587,0,0,1,58.988,310.539Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18068" data-name="Group 18068">
              <path
                id="Path_19115"
                data-name="Path 19115"
                d="M65.468,309.279a.588.588,0,1,1,.416-1l-.178.178a.337.337,0,1,0,0,.476l.178.178A.592.592,0,0,1,65.468,309.279Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18069" data-name="Group 18069">
              <path
                id="Path_19116"
                data-name="Path 19116"
                d="M61.736,304.282a.588.588,0,1,1,.416-1l-.177.178a.342.342,0,0,0-.477,0,.337.337,0,0,0,.477.477l.177.178A.588.588,0,0,1,61.736,304.282Z"
                fill="#d1752a"
              />
            </g>
          </g>
          <g
            id="Group_18077"
            data-name="Group 18077"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18071" data-name="Group 18071">
              <path
                id="Path_19117"
                data-name="Path 19117"
                d="M46.54,312.218a.587.587,0,1,1,.464-.947l-.2.153a.339.339,0,1,0-.061.474l.152.2A.58.58,0,0,1,46.54,312.218Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18072" data-name="Group 18072">
              <path
                id="Path_19118"
                data-name="Path 19118"
                d="M53.127,311.8a.625.625,0,0,1-.075-.005.584.584,0,0,1-.391-.224.587.587,0,0,1,.106-.824.587.587,0,0,1,.824.1l-.2.153a.338.338,0,1,0-.06.474l.152.2A.575.575,0,0,1,53.127,311.8Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18073" data-name="Group 18073">
              <path
                id="Path_19119"
                data-name="Path 19119"
                d="M50.064,306.363a.68.68,0,0,1-.077-.005.591.591,0,0,1-.508-.659.588.588,0,0,1,.225-.39.611.611,0,0,1,.435-.118.587.587,0,0,1,.389.225l-.2.152a.338.338,0,1,0-.312.542.336.336,0,0,0,.25-.067l.153.2A.579.579,0,0,1,50.064,306.363Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18074" data-name="Group 18074">
              <path
                id="Path_19120"
                data-name="Path 19120"
                d="M56.86,307.566a.68.68,0,0,1-.077-.005.588.588,0,0,1-.283-1.049.6.6,0,0,1,.434-.118.589.589,0,0,1,.39.225l-.2.152a.338.338,0,1,0-.062.475l.153.2A.586.586,0,0,1,56.86,307.566Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18075" data-name="Group 18075">
              <path
                id="Path_19121"
                data-name="Path 19121"
                d="M63.446,307.143a.646.646,0,0,1-.075-.005.581.581,0,0,1-.391-.223.588.588,0,1,1,.931-.719l-.2.152a.341.341,0,0,0-.225-.128.334.334,0,0,0-.25.068.337.337,0,0,0-.061.474.329.329,0,0,0,.224.128.339.339,0,0,0,.25-.067l.153.2A.58.58,0,0,1,63.446,307.143Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18076" data-name="Group 18076">
              <path
                id="Path_19122"
                data-name="Path 19122"
                d="M60.384,301.711a.659.659,0,0,1-.077-.005.589.589,0,0,1-.39-.225.587.587,0,0,1,.106-.824.6.6,0,0,1,.435-.118.586.586,0,0,1,.39.224l-.2.153a.338.338,0,1,0-.061.474l.152.2A.581.581,0,0,1,60.384,301.711Z"
                fill="#d1752a"
              />
            </g>
          </g>
          <g
            id="Group_18081"
            data-name="Group 18081"
            opacity="0.49"
            // style="mix-blend-mode: multiply;isolation: isolate"
          >
            <g id="Group_18078" data-name="Group 18078">
              <path
                id="Path_19123"
                data-name="Path 19123"
                d="M66.813,301.716a.584.584,0,0,1-.416-.174.588.588,0,0,1,.832-.831l-.177.177a.337.337,0,0,0-.477.477.344.344,0,0,0,.477,0l.177.176A.581.581,0,0,1,66.813,301.716Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18079" data-name="Group 18079">
              <path
                id="Path_19124"
                data-name="Path 19124"
                d="M73.293,300.455a.588.588,0,1,1,.416-1l-.178.178a.337.337,0,1,0,0,.477l.178.178A.59.59,0,0,1,73.293,300.455Z"
                fill="#d1752a"
              />
            </g>
            <g id="Group_18080" data-name="Group 18080">
              <path
                id="Path_19125"
                data-name="Path 19125"
                d="M69.561,295.457a.588.588,0,1,1,.416-1l-.177.178a.338.338,0,1,0,0,.477l.177.178A.588.588,0,0,1,69.561,295.457Z"
                fill="#d1752a"
              />
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};
export default PommeDeTerre;
